<template>
  <div class="modifyBanner">

    <div class="product-add">
      <!--form表单-->
      <el-form size="small" ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="标题" prop="title">
          <el-input  v-model="form.title" placeholder="请输入banner名称"></el-input>
        </el-form-item>
        <el-form-item label="业务场景" prop="biz_type">
          <el-select v-model="form.biz_type" placeholder="请选择业务场景" style="width: 100%;">
            <el-option v-for="item in bizTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="轮播图" prop="image_id">
          <el-row>
            <el-button icon="el-icon-picture-outline" @click="openUpload('logo')">选择图片</el-button>
            <div v-if="form.image_id!=''" class="img">
              <img :src="logo_file_path" width="100" height="100" />
            </div>
          </el-row>
        </el-form-item>
        <!-- <el-form-item label="跳转分类">
          <el-select v-model="form.url" style="width: 100%;" placeholder="请选择跳转分类">
            <el-option v-for="(item,index) in categoryList" :key="index" :label="item.name" :value="item.category_id"></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="跳转链接" prop="url">
          <el-input v-model="form.url" placeholder="选填，如 /pages/xxx 或完整链接" maxlength="255" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="跳转商品">
          <el-button type="primary" @click="isproduct=true">选择商品</el-button>
          <div class="productInfo" v-if="form.product_id&&form.product_id!=''">
            <el-button size="small" type="text" @click="form.product_id='';product={}">删除</el-button>
            <div class="pic" >
              <img v-img-url="product.cover_image" alt="" style="width: 80px; height: 80px;"/>
            </div>
            <div class="info">
              <div class="name">{{product.product_name }}</div>
            </div>
          </div>
        </el-form-item>
        <!-- <el-form-item label="位置" prop="position">
          <el-radio-group v-model="form.position">
            <el-radio :label="1">顶部轮播</el-radio>
            <el-radio :label="2">商品推荐</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="排序">
          <el-input-number v-model="form.sort"  :min="1" label="排序" step-strictly	></el-input-number>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>

        <!--提交-->
        <div style="text-align: center;">
          <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
          <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>

      <!--上传图片组件-->
      <Upload v-if="isupload" :isupload="isupload"  @returnImgs="returnImgsFunc">上传图片</Upload>

    </div>

    <Product style="z-index: 99999;" :isproduct="isproduct" @closeDialog="productChange"></Product>


  </div>
</template>

<script>
import Product from '@/components/product/Product';
import Upload from '@/components/file/Upload';
import BannerAPi from '@/api/banner.js';
export default {
  components:{Upload,Product},
  data(){
    return{
      isproduct:false,
      loading:false,
      isupload:false,
      form:{
        title:'',
        image_id:'',
        product_id:'',
        position:1,
        biz_type: 1,
        url: '',
        sort:1,
        status:1,
      },
      logo_file_path:'',
      product:{},
      rules:{
        title:{required: true,message: '请输入标题'},
        image_id:{required: true,message: '请上传轮播图'},
        position:{required: true,message: '请选择位置'},
        biz_type:{required: true,message: '请选择业务场景'},
      },
    }
  },
  props:{
    show: Boolean,
    bizTypeOptions: {
      type: Array,
      default: () => [],
    },
  },
  created(){

  },
  methods:{
    // 获取详情
    getData(id){
      this.form.id=id
      BannerAPi.bannerDetail({id:id}).then(result=>{
        let data=result.data.detail
        for(let i in this.form){
          if (data[i] !== undefined && data[i] !== null) this.form[i]=data[i]
        }
        // 旧数据可能无 biz_type，显示空白
        this.form.biz_type = (data.biz_type != null && data.biz_type >= 1 && data.biz_type <= 5) ? Number(data.biz_type) : ''
        if(data.product_id&&data.product_id!=''){
          this.product=data.product
        }
        this.form.url = (data.url != null && data.url !== '') ? String(data.url) : ''
        this.logo_file_path=data.file_path
      })
    },

    // 提交
    onSubmit(){
      let self = this;
      let form = self.form;
      self.$refs.form.validate((valid) => {
        if (valid) {
          self.loading = true;
          if(form.id&&form.id!=''){
            // 编辑
            BannerAPi.bannerEdit(form,true).then(result=>{
              self.$message({
                message: '编辑成功',
                type: 'success'
              });
              self.cancelFunc()
              self.$emit('save')
            }).finally(()=>{
              self.loading = false;
            })
            return
          }
          BannerAPi.bannerAdd(form,true).then(result=>{
            // console.log(result);
            self.$message({
              message: '添加成功',
              type: 'success'
            });
            self.cancelFunc()
            self.$emit('save')
          }).finally(()=>{
            self.loading = false;
          })
        }
      });
    },
         /*上传*/
    openUpload(e) {
      //  this.type = e;
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.logo_file_path = e[0].file_path;
        this.form.image_id = e[0].file_id;
      }
      this.isupload = false;
    },

    // 取消
    cancelFunc(){
      this.$emit('update:show',false)
    },

    productChange(e){
      // console.log(e);
      if(e.type=='success'){
        this.product=e.params
        this.product.cover_image=e.params.product_image
        this.form.product_id=e.params.product_id
      }
      this.isproduct=false
    },

  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/setting/banner/modifyBanner.vue